import { Center, Box } from '@chakra-ui/react'
import { DesignType } from 'types/generated/graphql'

export interface LayoutProps {
  disableSidebar?: boolean
  design?: DesignType
}

export const LayoutOpenArea: React.FC<LayoutProps> = ({ children, design }) => {
  return (
    <Box h="100vh" bg={`${design}.common.layerBackground`}>
      <Center>
        <Box w={{ base: '90%', md: '70%' }}>{children}</Box>
      </Center>
    </Box>
  )
}
